import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOptionalAuth } from '../../auth/AuthProvider';
import { INTERFACE_TEXT } from '../../constants/interfaceText';
import styles from './TodayScreen.module.css';

/** The language switcher (when there is one), the app name and, when signed in, the learner's email and Sign out. */
interface TodayHeaderProps {
  /** The language switcher, shown first (top left) when the learner has one to use. */
  switcher?: React.ReactNode;
}

export const TodayHeader: React.FC<TodayHeaderProps> = ({ switcher }) => {
  const auth = useOptionalAuth();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);
  const signOut = async (): Promise<void> => {
    if (!auth) return;
    setFailed(false);
    if (await auth.signOut()) {
      navigate('/sign-in', { replace: true });
    } else {
      setFailed(true);
    }
  };
  return (
    <header className={styles.top}>
      <div className={styles.brand}>
        {switcher}
        <span className={styles.appName}>{INTERFACE_TEXT.tdAppName}</span>
      </div>
      {auth && auth.state.status === 'signed-in' && (
        <div className={styles.account}>
          <span className={styles.email}>{auth.state.user.email}</span>
          {failed && (
            <span role="alert" className={styles.signOutError}>
              {INTERFACE_TEXT.tdSignOutFailed}
            </span>
          )}
          <button
            type="button"
            className={styles.signOut}
            onClick={() => void signOut()}
          >
            {INTERFACE_TEXT.tdSignOut}
          </button>
        </div>
      )}
    </header>
  );
};

export default TodayHeader;
